module.exports = __webpack_public_path__ + "static/media/img6.9c9de11b.jpeg";